import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingBienvenidaEmp: false,
  saveLoading: false,
  bienvenidaLength: 0,
  bienvenida: [],
  bienvenidaEmp: [],
};

export default function bienvenidaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_BIENVENIDA:
      return { ...state, loading: action.payload };
    case actions.LOADING_BIENVENIDA_EMPLEADO:
      return { ...state, loadingBienvenidaEmp: action.payload };
    case actions.SAVE_LOADING_BIENVENIDA:
      return { ...state, saveLoading: action.payload };
    case actions.GET_BIENVENIDA:
      return {
        ...state,
        bienvenida: action.payload.bienvenida,
      };
    case actions.GET_BIENVENIDA_EMPLEADO:
      return {
        ...state,
        bienvenidaEmp: action.payload.bienvenidaEmp,
      };
    default:
      return state;
  }
}
